/**
 * The product name and tagline, in one place: change them here and every screen follows.
 * The name is Dejo Dicho (decision 38), set in Lora. The tagline was approved by Mike and his wife
 * (decision 63) and is written by hand, in Caveat, as in her mockup.
 * Permanent names copied into outside services use the neutral word "jornada" instead (decision 30).
 */
export const brand = {
  name: 'Dejo Dicho',
  /** The company that sells and publishes the app (decision 69), written exactly this way everywhere. */
  seller: 'McKenna Works LLC',
  /** The name as the logo writes it. */
  wordmark: 'Dejo Dicho',
  tagline: { es: 'Más tiempo para ti, menos preocupaciones.', en: 'More time for you, fewer worries.' },
  showTagline: true,
} as const;
